import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { VideoContainer } from './Videos.style'
import { VIDEO_ERROR_TEXT } from '../../locales'

const Videos = ({ video, poster, className, hasObjectFit }) => (
  <VideoContainer
    title={video.videoTitle}
    className={className}
    description={video.videoDescription}
    playsInline
    poster={poster}
    autoPlay
    loop
    muted
    data-object-fit={hasObjectFit ? 'cover' : ''}
  >
    {
      video.videoFiles &&
      video.videoFiles.map(videoFile => (
        <source
          key={videoFile.file.url}
          src={videoFile.file.url}
          type={videoFile.file.contentType}
        />
      ))
    }
    <p>{VIDEO_ERROR_TEXT}</p>
  </VideoContainer>
)

Videos.propTypes = {
  video: PropTypes.shape({
    videoTitle: PropTypes.string.isRequired,
    videoFiles: PropTypes.instanceOf(Array).isRequired,
    videoDescription: PropTypes.shape({
      childMarkdownRemark: PropTypes.shape({
        rawMarkdownBody: PropTypes.string,
      }),
    }),
  }).isRequired,
  poster: PropTypes.string,
  className: PropTypes.string,
  hasObjectFit: PropTypes.bool,
}

Videos.defaultProps = {
  poster: '',
  className: '',
  hasObjectFit: false,
}

export default Videos

export const VideoFragment = graphql`
  fragment VideoFragment on ContentfulVideo {
    videoTitle
    videoDescription {
      childMarkdownRemark {
        rawMarkdownBody
      }
    }
    videoFiles {
      file {
        url
        contentType
      }
    }
  }
`
